<template>
  <div
    class="upload"
    v-loading="loading"
    element-loading-text="正在努力上传中..."
  >
    <h2 class="uploadTitle">上传答案</h2>
    <img class="uploadIcon" src="./image/zengzaikaoshi.png" alt="" />
    <img
      class="uploadButton"
      src="./image/zhaoxiang.png"
      v-if="isShow"
      alt=""
    />
    <p style="font-size: 14px; color: #999" v-if="isShow">
      你已上传成功，再上传请重新扫码
    </p>
    <img
      v-show="!isShow"
      @click="isOpen"
      class="uploadButton"
      src="./image/zhaoxiang.png"
      alt=""
    />
    <div v-if="imgData.length > 0">
      <img v-for="(item, index) in imgData" :key="index" class="imgData" :src="item" alt="" />
    </div>
    <el-drawer
      :visible.sync="drawer"
      :modal="false"
      :show-close="false"
      :direction="direction"
    >
      <ul class="chooseUpdata">
        <li>
          拍照上传
          <input
            class="input"
            @change="isUpData($event)"
            type="file"
            accept="image/*"
            capture="camera"
            value=""
          />
        </li>
        <li>
          从手机相册选择
          <input
            class="input"
            @change="isUpData($event)"
            type="file"
            accept="image/*"
            value=""
            multiple
          />
        </li>
        <li @click="drawer = false">取消</li>
      </ul>
    </el-drawer>
  </div>
</template>

<script>
import { faceServe } from "@/api/home";
import {uploadFiles, putObjectBlob} from "@/utils/upload";
import {getStore} from "@/utils/localStorage";

export default {
  name: "upload",
  data() {
    return {
      tag: '',
      ENTRANCETYPE: '',
      isShow: false,
      drawer: false,
      direction: "btt",
      imgData: [],
      loading: false,
    };
  },
  mounted() {
    if(this.$route.query._ENTRANCETYPE){
      this.ENTRANCETYPE = this.$route.query._ENTRANCETYPE;
      this.$store.dispatch('permission/SETENTRANCETYPE', this.$route.query._ENTRANCETYPE);
    }
    if(this.$route.query.tag){
      this.tag = this.$route.query.tag;
    }
  },
  methods: {
    handleUpdata() {
      this.loading = true;
    },
    handleAvatarSuccess() {
      this.isShow = true;
      this.loading = false;
    },
    //  上传失败的狗子
    handleError() {
      this.loading = false;
      this.$message.error("图片上传失败");
    },
    isOpen() {
      this.drawer = true;
    },
    async isUpData(e) {
      this.drawer = false;
      this.loading = true;
      let files = e.target.files;
      let type = e.target.files[0].type;
      const newFilses = Array.from(files);
      uploadFiles(newFilses, res => {
        this.imgData = res.split(',');
        faceServe.postPhoto({
          tag: this.tag,
          url: res.toString()
        }, this.tokenData).then(item => {

          if(item.data.code === 200) {
            this.loading = false;
            this.isShow = true;
          return
          }
          this.$message.error("图片上传失败");
        });
      }, null, 'question', type);

      // let files = e.target.files[0];
      // let type = files.type;
      // putObjectBlob(files, res => {
      //   this.imgData = res;
      //   faceServe.postPhoto({
      //     tag: this.mobileData,
      //     url: res
      //   }, this.tokenData).then(item => {

      //     if(item.data.code === 200) {
      //       this.loading = false;
      //       this.isShow = true;
      //      return
      //     }
      //     this.$message.error("图片上传失败");
      //   });
      // }, null, 'question')
      // let formData = new FormData();
      // formData.append("file", files);
      // formData.append("uuid", this.uuid.uuid);
      // const data = await faceServe.QRUpload(formData);
      // this.imgData = data;
      // if (data) {
      //   this.loading = false;
      //   this.isShow = true;
      // } else {
      //   this.$message.error("图片上传失败");
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.upload {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  background: url("./image/beijing.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.uploadIcon {
  width: 30%;
  position: absolute;
  right: 0;
  top: 5%;
}

.uploadTitle {
  font-size: 30px;
  color: #ffffff;
  font-weight: 400;
  margin-top: 10px;
}

.uploadButton {
  width: 180px;
  height: 180px;
  margin-top: 30px;
}

.imgData {
  width: 120px;
  height: 120px;
  margin-top: 20px;
}

.chooseUpdata {
  width: 100%;
}

.chooseUpdata li {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #000;
  position: relative;
}

.chooseUpdata li:first-child {
  border-bottom: 1px solid #f8f8f8;
}
.chooseUpdata li:last-child {
  border-top: 5px solid #f8f8f8;
}
.chooseUpdata li .input {
  width: 100%;
  height: 60px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

/deep/ .el-upload-list__item-name {
  display: none;
}

/deep/ .el-upload-list--picture .el-upload-list__item {
  height: 185px;
}

/deep/ .el-upload-list__item-thumbnail {
  width: 120px;
  height: 120px;
}

/deep/ .el-drawer__open .el-drawer.btt {
  height: 185px !important;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

/deep/ .el-drawer__header {
  margin-bottom: 0;
  padding: 0;
}
</style>
